import React, { useState } from 'react';
import toast from 'react-hot-toast';

// กำหนดรายการสีทั้งหมดที่มี โดย key ต้องตรงกับค่าใน p.settings.themeConfig
const THEME_OPTIONS = [
  { key: 'THEME:DARK_RED', color: '#912424' }, // สีแดงเข้ม
  { key: 'THEME:BURGUNDY', color: '#7e22ce' }, // สีเขียวเข้ม
  { key: 'THEME:INDIGO', color: '#a07ab2' }, // สีม่วงเข้ม
  { key: 'THEME:NAVY_BLUE', color: '#164563' }, // สีชมพู (เพิ่มเข้ามาตามตัวอย่าง)
  { key: 'THEME:FOREST_GREEN', color: '#846b48' }, // สีน้ำเงินเข้ม
  { key: 'THEME:TEAL', color: '#978c96' }, // สีน้ำตาลอ่อน (เพิ่มเข้ามาตามตัวอย่าง)
];

interface ThemeColorPickerProps {
  portfolioId: string;
  currentTheme: string; // ค่าปัจจุบันจาก p.settings.themeConfig
  onUpdateTheme: (portfolioId: string, themeKey: string) => Promise<void>;
  onClose: () => void; // Callback สำหรับปิด popup
}

const ThemeColorPicker: React.FC<ThemeColorPickerProps> = ({
  portfolioId,
  currentTheme,
  onUpdateTheme,
  onClose,
}) => {
  // State เก็บค่าสีที่เลือกชั่วคราว ก่อนกด OK
  const [selectedTheme, setSelectedTheme] = useState<string>(currentTheme);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleSelectColor = (themeKey: string) => {
    setSelectedTheme(themeKey);
  };

  const handleConfirm = async () => {
    if (selectedTheme === currentTheme) {
      onClose(); // ถ้าไม่ได้เปลี่ยนค่า ให้ปิด popup เฉยๆ
      return;
    }

    setIsLoading(true);
    try {
      // เรียกฟังก์ชัน update theme ที่รับมาจาก parent
      await onUpdateTheme(portfolioId, selectedTheme);
      // toast success จะถูกจัดการใน parent แล้ว (handleUpdateTheme)
      onClose(); // ปิด popup หลังจากอัปเดตสำเร็จ
    } catch (error) {
      console.error('Error updating theme:', error);
      // toast error จะถูกจัดการใน parent แล้ว
      setIsLoading(false); // ปิดสถานะโหลดหากเกิดข้อผิดพลาด
    }
  };

  return (
    <div
      className="absolute z-50  rounded-xl shadow-2xl p-4 border border-gray-500"
      style={{ width: '200px', top: '50px', right: '10px', backgroundColor: 'var(--component-bg-color)' }} // ปรับตำแหน่งตาม CSS ของ icon
      onClick={(e) => e.stopPropagation()} // กันคลิกโดนพื้นหลังการ์ดพอร์ต
    >
      {/* Grid สี 2x3 */}
      <div className="grid grid-cols-3 gap-3 mb-4  rounded-md p-2">
        {THEME_OPTIONS.map((option) => {
          const isSelected = selectedTheme === option.key;
          return (
            <div
              key={option.key}
              className={`relative w-10 h-10 rounded-full cursor-pointer transition-all hover:scale-110 flex items-center justify-center`}
              style={{ backgroundColor: option.color }}
              onClick={() => handleSelectColor(option.key)}
            >
              {/* วงแหวนแสดงสถานะเลือก */}
              {isSelected && (
                <div className="absolute -inset-1 border-2 border-yellow-400 rounded-full"></div>
              )}
            </div>
          );
        })}
      </div>

      {/* ปุ่ม OK */}
      <button
        className={`w-full py-2 rounded-lg font-bold text-sm transition-all ${
          isLoading
            ? 'bg-gray-600 cursor-not-allowed'
            : 'bg-green-600 hover:bg-green-700 active:scale-95 text-white'
        }`}
        onClick={handleConfirm}
        disabled={isLoading}
      >
        {isLoading ? 'กำลังบันทึก...' : 'ตกลง'}
      </button>
    </div>
  );
};

export default ThemeColorPicker;